module.exports = __webpack_public_path__ + "static/media/boatramp_marker_dark_blue.bb5fe9eb.svg";